import ReactDOM from 'react-dom/client';
import reportWebVitals from "./reportWebVitals";
import Root from "./root";
import "@abgov/web-components";
import { bootstrapDomainKeyRedirect } from "./MPP-Common-SPA/utils/globalUtility";

const renderApplication = () => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(<Root />);
  reportWebVitals();
};

bootstrapDomainKeyRedirect()
  .then((isRedirecting) => {
    if (!isRedirecting) {
      renderApplication();
    }
  })
  .catch((error) => {
    console.error("Domain key bootstrap redirect failed", error);
    renderApplication();
  });